import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from '../environment/environment.service';

export interface Notification {
  notification_id: string;
  user_id: string;
  event_type: string;
  reference_id: string;
  title: string;
  body: string;
  is_read: boolean;
  created_at: string;
  payload?: { task_code?: string; workflow_code?: string } | null;
  branch_number?: string;
  damage_status?: string;
}

export interface NotificationListResponse {
  notifications: Notification[];
  total_count: number;
  unread_count: number;
}

@Injectable({ providedIn: 'root' })
export class NotificationInboxService {
  private readonly http = inject(HttpClient);
  private readonly base = `${inject(EnvironmentService).apiUrls.notificationEngine}/v2/notifications`;

  getNotifications(params?: { limit?: number }) {
    return this.http.get<NotificationListResponse>(this.base, { params });
  }

  getUnreadCount() {
    return this.http.get<{ unread_count: number }>(`${this.base}/unread/count`);
  }

  markAsRead(id: string) {
    return this.http.patch<void>(`${this.base}/${id}/read`, {});
  }

  markAllAsRead() {
    return this.http.patch<void>(`${this.base}/read-all`, {});
  }
}
